module.exports = __webpack_public_path__ + "media/components/outside-promo-page/static/runners-0501ba7b7c3250bb666eeec1d71c8067.webp";